/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */

import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';

export type AppDispatch = ThunkDispatch<any, any, AnyAction>;

export const capitalizeFirstLetter = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const indicatorfiltersName = (filtersData: any, blockDimensions: any) => {
  const selectedCheckboxes = filtersData?.map((item: any) => {
    const key = Object.keys(item)[0];
    const index = blockDimensions.findIndex((block: any) => block?.name === key);
    if (item[key]?.length < 1) return null;
    if (item[key]?.length === blockDimensions[index]?.items?.length) return `All ${key}`;
    if (item[key]?.length === 1) return item[key][0];
    if (item[key]?.length < 3) return item[key]?.join(', ');
    if (item[key]?.length >= 3)
      return `${item[key]?.slice(0, 2).join(', ')}...(${item[key].length - 2})`;
  });

  return selectedCheckboxes;
};
